export default [{"name":"Home","path":"documentation/help/Home.help.mdx","order":1,"border":true,"permissions":[],"type":"FILE"}]